// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://api.dev.clearramp.com",
  cognito_client_id: "ssqs1ot6bcv77tpdj6kqpng5m",
  cognito_user_pool_id: "eu-central-1_D50hmg5qW",
  cognito_domain: "worktrest-test",
  vapidPublicKey: "BArW_w5nPdmwlJkPTNmz-EVn9i5LrKpTnGNdwSQ6XjRmG_qrA59b1UVjqM3pK1lbR5rkeuEScPDj1C6lqCQvEss",
  logostore: "https://assets.dev.clearramp.com/",
  cookie_domain: "dev.clearramp.com",

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeProject`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
